import { FC, useContext } from "react";
import {
    styled,
    Container,
    Box,
    Typography,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel
} from "@mui/material";

import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { Store } from "../store";
import { useLanguage } from "../hooks/useStoreGetters";
import { useTranslation } from 'react-i18next';
import { VisualizedMenus } from "../components/VisualizedMenus";
import { Toolbar } from "../components/FooterToolbar";
import { themeColors } from "../common/colors";
import { useCustomMediaQuery } from "../common/useCustomMediaQuery";
import { pageMt } from "../common/util";

const LINE_CHART_SIZE: number[] = [
    800, 320
];

const Title = styled(Box)(() => ({
    position: "relative",
    width: '100%',
    height: 'auto',
    maxWidth: `${LINE_CHART_SIZE[0]}px`,
    margin: 'auto',
    borderBottom: `solid 1px ${themeColors[0]}`,
    color: `${themeColors[0]}`,
    textAlign: 'left',
    marginBottom: '2rem',
}));

const LanguagePage: FC = () => {
    const { t, i18n } = useTranslation();
    const { isDesktop } = useCustomMediaQuery();
    const { dispatch } = useContext(Store);
    const language = useLanguage();
    const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newLanguage = event.target.value;
        dispatch({ type: 'SET_LANGUAGE', payload: { language: newLanguage } });
        i18n.changeLanguage(newLanguage);
        localStorage.setItem('selectedLanguage', newLanguage);
    };

    return (
        <Container maxWidth="xl">
            <VisualizedMenus />
            <Box mt={pageMt(isDesktop)} className="mb-2 p-2 w-[80%] mx-auto" maxWidth={`${LINE_CHART_SIZE[0]}px`}>
                <Title>
                    <Typography variant="h5" style={{ marginTop: 10, textAlign: "left" }}>
                        <LanguageOutlinedIcon sx={{ margin: '.5rem .8rem' }} />{t('menu.language')}
                    </Typography>
                </Title>
                <FormControl >
                    <RadioGroup value={language} onChange={handleLanguageChange}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            marginTop: 2,
                        }}
                    >
                        <FormControlLabel value="ja" control={<Radio />} label={t("language.ja")} />
                        <FormControlLabel value="en" control={<Radio />} label={t("language.en")} />
                    </RadioGroup>
                </FormControl>
            </Box>
            <Toolbar />
        </Container>
    )
}

export default LanguagePage;


